var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7162_20513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7162_20513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 9.65625L9.89062 8.85938L7.5625 6.53125V3.25H6.4375V7L9.09375 9.65625ZM7 13C6.17313 13 5.39609 12.8438 4.66891 12.5312C3.94172 12.2188 3.30469 11.7891 2.75781 11.2422C2.21094 10.6953 1.78125 10.0575 1.46875 9.32875C1.15625 8.6 1 7.82135 1 6.99281C1 6.16427 1.15625 5.38542 1.46875 4.65625C1.78125 3.92708 2.21094 3.29167 2.75781 2.75C3.30469 2.20833 3.9425 1.78125 4.67125 1.46875C5.4 1.15625 6.17865 1 7.00719 1C7.83573 1 8.61464 1.1575 9.34391 1.4725C10.0731 1.7875 10.7074 2.215 11.2469 2.755C11.7863 3.295 12.2133 3.93 12.528 4.66C12.8427 5.39 13 6.17 13 7C13 7.82687 12.8438 8.60391 12.5312 9.33109C12.2188 10.0583 11.7917 10.6953 11.25 11.2422C10.7083 11.7891 10.0722 12.2188 9.34172 12.5312C8.6112 12.8438 7.83063 13 7 13Z",
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.bda0fe4d.svg";
export { ForwardRef as ReactComponent };